import { useNavigate } from 'react-router';
import { useRunScenario, useScenarios } from '../api/hooks';
import { Button, Card, ErrorBox, PageHeader, Spinner } from '../components/ui';
import { useToast } from '../components/toast';

export default function Scenarios() {
  const navigate = useNavigate();
  const toast = useToast();
  const { data, isPending, error } = useScenarios();
  const run = useRunScenario();

  if (error) return <ErrorBox error={error} />;
  if (isPending) return <Spinner />;

  return (
    <div className="space-y-5">
      <PageHeader title="Scénarios de recette" />
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {(data ?? []).map((scenario) => (
          <Card key={scenario.name} className="flex flex-col justify-between gap-3">
            <div>
              <p className="text-lg font-bold text-white">{scenario.title}</p>
              <p className="mt-1 text-sm text-on-surface-variant">{scenario.description}</p>
              <p className="mt-2 font-mono text-[11px] text-outline">{scenario.name}</p>
            </div>
            <div>
              <Button
                variant="primary"
                disabled={run.isPending}
                onClick={() =>
                  run.mutate(scenario.name, {
                    onSuccess: (result) => {
                      toast.success(`Commande ${result.commande.idCommande} créée`);
                      navigate(`/commandes/${result.commande.guid}`);
                    },
                    onError: (err) => toast.error(err),
                  })
                }
              >
                Créer
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
